import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ResponseBody } from '@shared/model/response-body.models';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class VerificationMarketerService {
  private readonly baseUrl = environment.baseUrl;
  private readonly routePrefix = 'api/v1/admin/user/marketer';

  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar
  ) { }


  getMarketerList(startPage: number, pageSize: number): Observable<any> {
    return this.http.get(`${this.baseUrl}/${this.routePrefix}/verification?startPage=${startPage}&pageSize=${pageSize}`)
    .pipe(map((res: any) => res.data));
  }

  updateMarketer(id: number, inline): Observable<ResponseBody> {
    return this.http.patch(`${this.baseUrl}/${this.routePrefix}/verification/${id}`, inline)
    .pipe(map((res: any) => {
      if (res.status === 200 || res.status === 201) {
        this.snackBar.open(res.message , 'Undo', {
          duration: 1000
        })
      return  res.data
    }}
   ));

  }
}
